import Axios from 'axios'
import config from './config'

const apiUrls = {
  remote : config.templatesRemoteApiUrl,
  local : config.templatesLocalApiUrl 
}

const getSystemTemplates = async ({apiSource,apiKeys}) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/getSystemTemplates/`,
    }

    let data = await callApi({apiSource,apiKeys,options})
    return data.templates
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting system templates"}
  }
}

const getClientTemplates = async ({apiSource,apiKeys}) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/getClientTemplates/`,
    }

    let data = await callApi({apiSource,apiKeys,options})
    return data.templates
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting client templates"}
  }
}


const getClientTemplate = async ({apiSource,apiKeys, templateId}) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/getClientTemplate/${templateId}`,
    }

    let data = await callApi({apiSource,apiKeys,options})
    return data.template
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting client template"}
  }
}

const updateClientImage = async ({apiSource,apiKeys,image}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateClientImage`,
      method: "patch",
      data:{
        image
      }
    }

    return await callApi({apiSource,apiKeys,options})  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error updating image"}
  }
} 


const getTemplateData = async ({apiSource,apiKeys, templateId}) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/getTemplateData/${templateId}`,
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting template data"}
  }
}

const createTemplate = async ({apiSource,apiKeys,templateId,templateName}) => {
  try {
    let options = {
      method: 'POST',
      url: `${apiUrls[apiSource]}/createTemplate/`,
      data : {
        sourceTemplateId : templateId,
        newTemplateName : templateName,
      }
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error creating template"}
  }
}

const duplicateTemplate = async ({apiSource,apiKeys,templateId,newtemplateName}) => {
  try {
    let options = {
      method: 'POST',
      url: `${apiUrls[apiSource]}/duplicateTemplate/`,
      data : {
        sourceTemplateId : templateId,
        newTemplateName : newtemplateName,
      }
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error duplicating template"}
  }
}


const archiveTemplate = async ({apiSource,apiKeys, templateId}) => {
  try {
    let options = {
      method: 'PATCH',
      url: `${apiUrls[apiSource]}/archiveTemplate/` + templateId
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error archiving template"}
  }
}

const unarchiveTemplate = async ({apiSource,apiKeys,templateId}) => {
  try {
    let options = {
      method: 'PATCH',
      url: `${apiUrls[apiSource]}/unarchiveTemplate/` + templateId
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error unarchiving template"}
  }
}

const searchGooglePlaystore = async ({apiSource,apiKeys, searchTerm}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/searchGooglePlayStore`,
      method: "get",
      params: {
        term: searchTerm
      }
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error searching playstore"}
  }
}

const searchAppleAppstore = async ({ apiSource, apiKeys, countryCode, searchTerm }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/searchAppleAppstore`,
      method: "get",
      params: {
        countryCode,
        term : searchTerm
      }
    }

    return await callApi({apiSource,apiKeys,options})  
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error searching appstore"}
  }
}

const saveAppleModel = async ({ apiSource, apiKeys,templateId,appleModel }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateAppleModel`,
      method: "post",
      data : {
        templateId,
        appleModel
      }
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error saving apple model"}
  }
}

const saveAppleTemplate = async ({ apiSource, apiKeys,templateId,appleTemplate }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateAppleTemplate`,
      method: "post",
      data : {
        templateId,
        appleTemplate
      }
    }

    let result = await callApi({apiSource,apiKeys,options})
    
    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error saving apple template"}
  }
}


const saveGoogleData = async ({ apiSource, apiKeys,templateId,googleClass, googleObject }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateGoogleData`,
      method: "post",
      data : {
        templateId,
        googleClass,
        googleObject
      }
    }

    let result = await callApi({apiSource,apiKeys,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error saving google both"}
  }
}

const saveGoogleClass = async ({ apiSource, apiKeys,templateId,googleClass }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateGoogleClass`,
      method: "post",
      data : {
        templateId,
        googleClass
      }
    }

    let result = await callApi({apiSource,apiKeys,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error saving google class"}
  }
}

const saveGoogleObject = async ({ apiSource, apiKeys,templateId,googleObject }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateGoogleObject`,
      method: "post",
      data : {
        templateId,
        googleObject
      }
    }

    let result = await callApi({apiSource,apiKeys,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error saving apple object"}
  }
}

const saveMetaData = async ({ apiSource, apiKeys,templateId,metaData }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateMetaData`,
      method: "post",
      data : {
        templateId,
        metaData
      }
    }

    let result = await callApi({apiSource,apiKeys,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error saving meta data"}
  }
}
const saveInstanceData = async ({ apiSource, apiKeys,templateId,instanceData }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updateInstanceData`,
      method: "post",
      data : {
        templateId,
        instanceData
      }
    }

    let result = await callApi({apiSource,apiKeys,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error saving instance data"}
  }
}

const setWizardDone = async ({ apiSource, apiKeys,templateId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/setWizardDone/${templateId}`,
      method: "patch"
    }

    let result = await callApi({apiSource,apiKeys,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error setting wizard done"}
  }
}


const setGoogleBarcodeHandling  = async ({ apiSource, apiKeys, templateId, disableBarcode }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/setGoogleBarcodeHandling/${templateId}/${disableBarcode ? 1 : 0}`,
      method: "patch",
      data : {}
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error setting google barcode handling"}
  }
}

const getTemplateIssueData = async ({apiSource,apiKeys,templateId}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getTemplateIssueData/${templateId}`,
      method: "get"
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting issue data"}
  }
}

const uploadClientImage = async ({apiSource,apiKeys,device,imageType, passType,filename,base64Data}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/uploadClientImage`,
      method: "put",
      data:{
        device,
        image_type : imageType,
        pass_type : passType,
        filename,
        base64Data
      }
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error uploading image"}
  }
}

const getClientImages = async ({apiSource,apiKeys,filetypes=["png","jpg","jpeg"]}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getClientImages`,
      method: "get"
    }

    const result = await callApi({apiSource,apiKeys,options})
    result.images = result.images.filter(i => filetypes.includes(i.file_type))
    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting images"}
  }
}


const getPassTypeData = async ({apiSource,apiKeys, passType}) => {
  try {
    let options = {
      method: 'GET',
      url: `${apiUrls[apiSource]}/getPassTypeData/` + passType,
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting pass type data"}
  }
}


const saveScannerConfiguration = async ({apiSource,apiKeys,templateId,scannerData}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/saveScannerConfiguration/${templateId}`,
      method: "patch",
      data:{scannerData}
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error saving scanner configuration"}
  }
}

const getScanReportDates = async ({apiSource,apiKeys,templateId}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getScanReportDates/${templateId}`,
      method: "get",
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting scan report dates"}
  }
}


const getScanReportScans = async ({apiSource,apiKeys,templateId,ts}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getScanReportScans/${templateId}/${ts}`,
      method: "get",
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting scan report scans"}
  }
}

const renameTemplate = async ({apiSource,apiKeys,templateId,name}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/renametemplate/${templateId}/${name}`,
      method: "patch",
    }

    return await callApi({apiSource,apiKeys,options})
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error renaming template"}
  }
}

const callApi = async ({apiSource,apiKeys, apiMode,options}) => {
  try {
    const mode = apiMode ?? Object.keys(apiKeys)[0]

    if (apiSource === "local") {
      options.headers = {
        'x-api-key': config.localApiKey,
        'Authorization': apiKeys[mode],
        'Content-type': 'application/json',
      }
    } else {
      options.headers = {
        'x-api-key': apiKeys[mode],
        'Content-type': 'application/json',
      }
    }

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    throw err
  }
}

export {
  archiveTemplate, 
  createTemplate, 
  duplicateTemplate,
  getClientTemplate,
  getClientTemplates,
  getPassTypeData,
  getClientImages,
  getSystemTemplates,
  getTemplateData,
  getTemplateIssueData,
  saveAppleModel,
  saveAppleTemplate,
  saveGoogleClass,
  saveGoogleData,
  saveGoogleObject,
  saveMetaData,
  saveInstanceData,
  saveScannerConfiguration,
  searchAppleAppstore,
  searchGooglePlaystore,
  setGoogleBarcodeHandling,
  setWizardDone,
  unarchiveTemplate,
  updateClientImage,
  uploadClientImage,
  getScanReportDates,
  getScanReportScans,
  renameTemplate,
}

